@if (src()) {
  <img
    class="inline-block"
    [class.rounded-full]="mode === 'circle'"
    ngSrc="{{ src() }}"
    [height]="height"
    [width]="width"
    [priority]="priority"
    [attr.alt]="GameEntityTypeTexts[type].singular"
  />
}
